import React, { FC } from 'react';
import classNames from 'classnames';
import ControlGroupTip from './ControlGroupTip';
import classes from './styles/index.module.scss';
import { TooltipValidationSection } from './TooltipValidationSection';
import { isMobile } from '../../../utils/device';
import { PaddingBox } from '../../PaddingBox';
import { ControlGroupProps } from '../types';

export const ControlGroupLabelSection: FC<React.PropsWithChildren<ControlGroupProps>> = (props) => {
	const {
		label,
		labelSectionClassName: labelSectionClassFromProps,
		labelClassName: labelClassNameFromProps,
		labelBold,
		labelLight = true,
		labelWhite,
		validationMessagePlace,
		disabled,
		uploadButtonLabel,
		hasTip,
		hasAfterLabel,
		labelBeforeComponent,
		beforeLabel,
		labelWFull,
	} = props;

	const labelSectionClasses = classNames(classes.labelSection, labelSectionClassFromProps, {
		[classes.labelSection_hasTip]: hasTip || hasAfterLabel,
		[classes.labelSection_bold]: labelBold,
		[classes.labelSection_beforeComponent]: labelBeforeComponent,
	});

	const labelClassName = classNames(classes.label, labelClassNameFromProps, {
		[classes.label_light]: labelLight,
		[classes.label_wFull]: labelWFull,
		[classes.label_white]: labelWhite,
		[classes.label_bold]: labelBold,
		[classes.label_uploadButton]: uploadButtonLabel && !disabled,
		[classes.label_beforeComponent]: labelBeforeComponent && !hasTip && !hasAfterLabel,
	});

	return (
		<div
			className={labelSectionClasses}
			data-testid='controlGroupLabelSection'
		>
			{beforeLabel && <PaddingBox rightScanty>{beforeLabel}</PaddingBox>}
			<label
				className={labelClassName}
				data-testid='controlGroupLabelSection__label'
			>
				{label}
			</label>
			{hasAfterLabel && props.afterLabel}
			{hasTip && <ControlGroupTip {...props} />}
			{!isMobile && validationMessagePlace === 'title' && (
				<TooltipValidationSection
					{...props}
					className={classes.titleValidationBtnTip}
				/>
			)}
		</div>
	);
};
